import { Injectable } from '@angular/core';
import { CxEvent } from '@spartacus/core';
import { GtmCollectorService } from '@spartacus/tracking/tms/gtm';

@Injectable({ providedIn: 'root' })
export class GonvarriTrackingCollectorService extends GtmCollectorService {
  map<T extends CxEvent>(event: T): T | object {
    const eventType = (event.constructor as typeof CxEvent).type;
    return { ...event, event: eventType };
  }
}
